import React from 'react'
import { Alert } from 'react-bootstrap'
import {
  Checkbox, TextField, validateFieldsEx, BankAccountName,
} from '../../../../shared/fields'
import { ApplicationModel } from '../../../../models/ApplicationModel'
import { MaskedField } from '../../../../shared/fields/MaskedField'
import { ApplicationController } from '../../../../controllers/ApplicationController'
import { ISupportSpinner } from '../../../../shared/Ajax'
import { Backdrop } from '../../../../shared/Backdrop'
import EMDGAccordion from '../../../../shared/EMDGAccordion'
import { ApplicationFetch } from '../../../../controllers/ApplicationFetch'

export interface Props {
    model: ApplicationModel
    onChange: { (changes: Partial<ApplicationModel>, callback?: { (): any }): any }
    preview?: boolean
}

export interface State {
    loading: boolean,
    excludedAscii: string[]
}

export default class BankDetails extends React.Component<Props, State> implements ISupportSpinner {
  ajax: ApplicationController
  applicationFetch = new ApplicationFetch()

  bankStateBranchNumber: MaskedField
  financialInstitutionName: TextField
  bankAccountNumber: TextField
  bankAccountName: TextField
  confirmBankAccountDetails: Checkbox
  constructor(props: Props) {
    super(props)

    this.ajax = new ApplicationController()

    this.state = {
      loading: false,
      excludedAscii: [],
    }
  }

  componentDidMount() {
    this.applicationFetch.getBankNameExcludedAsciiString()
      .then((data: string[]) => {
        this.setState({ excludedAscii: data })
      })
      .catch((error) => {
        console.error('Error fetching Bank Name Excluded Ascii:', error);
      });
  }

  componentDidUpdate(prevProps: Props) {
    const { model, onChange } = this.props
    if (model.bankStateBranchNumber !== prevProps.model.bankStateBranchNumber
            && model.bankStateBranchNumber
            && (model.bankStateBranchNumber.match(/\d/g) || '').length === 6) {
      this.ajax.bsbSearch(
        this,
        model.bankStateBranchNumber,
        (bsb) => {
          if (bsb) {
            onChange({
              financialInstitutionName: `${bsb.institutionCode}-${bsb.institutionName}`,
              bsbInvalid: false,
            })
          } else {
            onChange({
              financialInstitutionName: '',
              bsbInvalid: true,
            })
          }
        },
      )
    }
  }

  validate(callback: { (res: boolean): any }, focus?: boolean) {
    validateFieldsEx(
      focus,
      callback,
      this.bankStateBranchNumber,
      this.financialInstitutionName,
      this.bankAccountNumber,
      this.bankAccountName,
      this.confirmBankAccountDetails,
    )
  }

  validateBankName(): string {
    if (this.props.model.bankAccountName?.length > 0 && this.state.excludedAscii?.length > 0) {
      if (this.state.excludedAscii.some((excl) => this.props.model.bankAccountName.indexOf(excl) > -1)) {
        return 'Bank account name format is incorrect'
      }
    }
    return ''
  }

  toggleSpinner(on: boolean, callback: { (): any }): void {
    this.setState({ loading: on }, callback)
  }

  render() {
    const { model, onChange, preview } = this.props
    const { loading } = this.state
    return (
      <div className="form-item">
        { preview && <h4>Application bank details</h4>}
        <EMDGAccordion expanded header="Application bank details">
          <p>Provide your bank account details for the grant payment. We can only pay funds directly to the organisation that will be party to a grant agreement with the Commonwealth. </p>

          <MaskedField
            ref={(r) => { this.bankStateBranchNumber = r }}
            id="accountBsb"
            label="BSB Number"
            value={model.bankStateBranchNumber}
            onChange={(bankStateBranchNumber) => onChange({ bankStateBranchNumber })}
            block={false}
            mask="999-999"
            required
            errorMessage={model.bankStateBranchNumber && (model.bankStateBranchNumber.match(/\d/g) || '').length !== 6 && 'Bsb number must be 6 digits'}
            preview={preview}
          />
          {model.bsbInvalid && (
            <Alert className="emdg-page-alerts emdg-page-alerts--warning">
              The BSB you entered was not on our list. We will be in contact to confirm the details once the application is lodged.
            </Alert>
          )}
          <TextField
            ref={(r) => { this.financialInstitutionName = r }}
            id="financialInstitutionName"
            label="Financial Institution and Branch"
            value={model.financialInstitutionName}
            onChange={(financialInstitutionName) => onChange({ financialInstitutionName })}
            required
            maxLength={80}
            preview={preview}
          />
          <TextField
            ref={(r) => { this.bankAccountNumber = r }}
            id="bankAccountNumber"
            label="Account number"
            value={model.bankAccountNumber}
            onChange={(bankAccountNumber) => onChange({ bankAccountNumber })}
            regex={'^(?!0+$)(\\d+$)'}
            regexMessage="Account number is invalid"
            required
            maxLength={9}
            preview={preview}
          />

          <TextField
            ref={(r) => { this.bankAccountName = r }}
            id="bankAccountName"
            label="Name of bank account"
            value={model.bankAccountName}
            onChange={(bankAccountName) => onChange({ bankAccountName })}
            required
            maxLength={32}
            errorMessage={this.validateBankName()}
            preview={preview}
          />

          {/* <BankAccountName
              ref={(r) => { this.bankAccountName = r }}
              id="bankAccountName"
              label="Name of bank account"
              value={model.bankAccountName}
              onChange={(bankAccountName) => onChange({ bankAccountName })}
              required
              maxLength={32}
              preview={preview}
              excludedAscii={this.state.excludedAscii}
            /> */}

          <div className="form-item">
            <Checkbox
              ref={(r) => { this.confirmBankAccountDetails = r }}
              id="bankDetailsConfirmed"
              required
              onChange={(val) => onChange({ confirmBankAccountDetails: val || null })}
              value={model.confirmBankAccountDetails}
              label="I confirm that the bank account details are correct and authorise Austrade to pay grant funds into this bank account."
              preview={preview}
            />
            {model.confirmBankAccountDetails
            && (
            <Alert className="emdg-page-alerts">
              Please double check this information is correct as Austrade will not be held responsible for funds
              {' '}
              that are transferred to the wrong bank account as a result of your input error nor spend government funds
              {' '}
              attempting to recover your funds as a result of your error.
              {' '}
              EMDG applicants have previously regularly entered incorrect information.
            </Alert>
            )}
          </div>
        </EMDGAccordion>
        <Backdrop on={loading} />
      </div>
    )
  }
}
